import * as React from "react";
import AllProfiles from "../profiles/AllProfiles";
import ProfileFilters from "../profiles/ProfileFilters";
// import { profiles } from '../mockdata/profiles';
//MUI components
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Header from "../header/Header";
import AuthContext from "../Context/AuthProvider";
//css
import "./homepage.css";
import { createFilterQuery, getProfiles, postFetchUserMessage } from "../../services/profile";
import { FAILED_TO_FETCH_PROFILES_MESSAGE, PAGE_SIZE } from "../constants/Constants";
import { ToastContainer, toast } from "react-toastify";
import { cacheFilterState } from "../common/utilities/FilterTranslator";
import {
  cancelOrder,
  createOrder,
  validateOrder,
} from "../../services/payment";
import GenericModal, {
  EVENT_MODAL_ERROR,
  EVENT_MODAL_LOAD,
  EVENT_MODAL_SUCCESS,
} from "../common/GenericModal";
import PreviewModal from "../acknowledgements/PreviewModal";
import PaymentModal from '../common/PaymentModal';
import { LOCALSTORAGE_HOMEPAGE_PAGENUMBER } from "../../services/Constants";

export const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 500,
  bgcolor: "white",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function HomePage() {
  const { 
    profile, 
    getToken, 
    isUserPaymentValid, 
    filterState, 
    setFilterState, 
    userRole, 
    areFiltersLoaded,
    shouldUserViewPreviewIntro
  } = React.useContext(AuthContext);
  // const [allProfiles, setAllProfiles] = React.useState([]);
  const [filteredProfiles, setFilteredProfiles] = React.useState([]);
  const [searchText, setSearchText] = React.useState("");
  const searchTextRef = React.useRef(searchText);
  const [localFilterState, setLocalFilterState] = React.useState(filterState);
  const headerRef = React.useRef(null); // Reference to the header section
  const [paymentModalOpenState, setPaymentModalOpenState] =
    React.useState(false);

  const [eventModalOpenState, setEventModalOpenState] = React.useState(false);
  const [eventModalType, setEventModalType] = React.useState("");
  const [eventModalText, setEventModalText] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [previewModalOpen, setPreviewModalOpen] = React.useState(false);
  const [firstRenderCompleted, setFirstRenderCompleted] = React.useState(false);

  const openEventModal = (
    eventType,
    eventMessage,
    dismissAutomatically = false
  ) => {
    if (!eventModalOpenState) {
      setEventModalType(eventType);
      setEventModalText(eventMessage);
      setEventModalOpenState(true);
    }
    if (dismissAutomatically) {
      setTimeout(() => {
        closeEventModal();
      }, 5000);
    }
  };

  const closeEventModal = () => {
    setEventModalType("");
    setEventModalText("");
    setEventModalOpenState(false);
  };

  const getOrDefaultLocalStoragePage = () => {
    const stored = localStorage.getItem(LOCALSTORAGE_HOMEPAGE_PAGENUMBER);
    return stored ? Number(stored) : 1;
  };
  const [currentPage, setCurrentPage] = React.useState(getOrDefaultLocalStoragePage());
  const [totalPages, setTotalPages] = React.useState(1);
  const timerRef = React.useRef(null);

  const isAdmin = userRole === "admin";

  const invokeApplyProfileFilterWithDelay = (firstRender = false, currentPagePassed = null, timeoutPeriod = null) => {
    if(timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      applyProfileFilter(firstRender, currentPagePassed);
    }, timeoutPeriod);
  }

  // firstRender indicates wether we are loading the profiles first time. We need this to keep filterState and localfilterstate in sync
  const applyProfileFilter = (firstRender = false, currentPagePassed = null) => {
		if(!areFiltersLoaded || loading) return;
    if(!firstRender && !firstRenderCompleted) return;
   
    if(currentPagePassed === null || currentPagePassed === undefined || currentPagePassed === 0)
      currentPagePassed = firstRender ? currentPage ?? 1 : 1;

    // Use the ref to get the current searchText value
    const searchTextToUse = searchTextRef.current;

    var applicableFilters = firstRender ? filterState :localFilterState;
    let filters = [],
      age = applicableFilters.ageFilterState, height = applicableFilters.heightFilterState;

    Object.keys(applicableFilters).forEach((key) => {
      if (key !== "ageFilterState" && key !== "heightFilterState") {
        filters.push(applicableFilters[key]);
      }
    });
    if (isAdmin || (!isAdmin && "firstName" in profile && (profile.gender === "male" || profile.gender === "female"))) {
      !loading && setLoading(true);
      let listOfFilters = createFilterQuery(filters, age, isAdmin ? "" : profile.gender, height);
      let auth = getToken();
      if (auth) {
        try {
          getProfiles(
            auth.token,
            listOfFilters,
            currentPagePassed,
            PAGE_SIZE,
            searchTextToUse
          ).then((response) => {
            if (response.data.errors) {
              // setAllProfiles([]);
              console.error("error response from backend in fetching profiles");
              toast.error(FAILED_TO_FETCH_PROFILES_MESSAGE, {timeOut: 4000});
              setFilteredProfiles([]);
              setCurrentPage(1);
            } else {
              
              let profiles, totalPages;
              if (response.data.data.filter) {
                profiles = response.data.data.filter.profiles;
                totalPages = response.data.data.filter.total_pages;
              } else {
                profiles = response.data.data.search.profiles;
                totalPages = response.data.data.search.total_pages;
              }
              // setAllProfiles(profiles);
              postFetchUserMessage(totalPages);
              let remainingProfiles = profiles.filter(
                (currentProfile) => currentProfile.id !== profile.id
              );
              setFilteredProfiles(remainingProfiles);
              setTotalPages(totalPages);
              cacheFilterState({...applicableFilters});
              setFilterState({...applicableFilters});
              if(firstRender)
                setLocalFilterState({...applicableFilters});
              currentPagePassed !== currentPage && setCurrentPage(currentPagePassed);
              // Scroll to the top
              setTimeout(() => {
                if (headerRef.current) {
                  headerRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
                }
              }, 500); // Adding a small delay to ensure UI updates
            }
          });
        } catch (error) {
          console.error("error in fetching profiles", error);
          toast.error(FAILED_TO_FETCH_PROFILES_MESSAGE, {timeOut: 4000})
          setCurrentPage(1);
          setFilteredProfiles([]);
        } finally {
          !firstRenderCompleted && setFirstRenderCompleted(true);
          setLoading(false);
        }
      }
    }
  };

  const handleMakePayment = async () => {
    let auth = getToken();
    if (auth) {
      try {
        setPaymentModalOpenState(false);
        openEventModal(EVENT_MODAL_LOAD, "Generating order request");

        // Await the createOrder response
        const response = await createOrder(auth.token);
        if (response.data.errors) {
          console.error(
            "Error in generating order request",
            response.data.errors
          );
          openEventModal(
            EVENT_MODAL_ERROR,
            "There was an issue with generating order. Please try again after some time. Please contact support +91 8296919479, if issue continues. If you have made a payment recently, please give us some time to process the payment."
          );
        } else {
          // Assuming response structure contains the order data
          const orderData = response.data.data.createOrder;
          var amount = parseInt(orderData.amount, 10);
          const options = {
            key: process.env.REACT_APP_RAZORPAY_KEY,
            amount: amount,
            currency: "INR",
            name: "GSB Soirika",
            description: "Transaction for GSB paid membership",
            order_id: orderData.orderId,
            timeout: orderData.remainingTimeInSeconds,

            handler: async function (response) {
              try {
                openEventModal(
                  EVENT_MODAL_LOAD,
                  "Validating order request",
                  true
                );
                var paymentId = response.razorpay_payment_id ?? "";
                var signature = response.razorpay_signature ?? "";
                const validationResponse = await validateOrder(
                  auth.token,
                  paymentId,
                  signature
                );

                if (validationResponse.data.data.ValidatePayment) {
                  openEventModal(
                    EVENT_MODAL_SUCCESS,
                    "Payment receieved! We will process your request offline and update your status within 3 days. Please reach out +91 8296919479, for any concerns",
                    true
                  );
                  toast.info("Redirecting...", { timeOut: 5000 });
                  setTimeout(() => {
                    window.location.reload();
                  }, 5000);
                } else {
                  console.error(
                    "Error in validating order",
                    validationResponse.data.errors
                  );
                  openEventModal(
                    EVENT_MODAL_ERROR,
                    "There was an issue with validating the order. Please note order id " +
                      orderData.orderId +
                      ", We will process your request offline and update your payment status accordingly. We request you to please contact support +91 8296919479, if your account is not activated in 3 days."
                  );
                }
              } catch (error) {
                console.error("Error in validating order", error);
                openEventModal(
                  EVENT_MODAL_ERROR,
                  "There was an issue with validating the order. Please note order id " +
                    orderData.orderId +
                    ", We request you to keep a note of the transaction and please contact support +91 8296919479, if your account is not activated in 3 days."
                );
              }
            },
            modal: {
              backdropclose: false,
              confirm_close: true,
              ondismiss: async () => {
                try {
                  const cancelResponse = await cancelOrder(
                    auth.token,
                    orderData.orderId
                  );
                  if (cancelResponse.data.data.cancelOrder) {
                    toast.info("Transaction cancelled", { timeOut: 1000 });
                    closeEventModal();
                  } else {
                    closeEventModal();
                    toast.info(
                      "Transaction is being cancelled. Please attempt payment after sometime",
                      { timeOut: 2000 }
                    );
                    console.error(
                      "failed to cancel transaction, received error",
                      cancelResponse.data.errors
                    );
                  }
                } catch (error) {
                  openEventModal(
                    EVENT_MODAL_ERROR,
                    "Transaction is being cancelled. Please attempt payment after sometime"
                  );
                  console.error(
                    "failed to cancel transaction, received error",
                    error
                  );
                }
              },
            },
          };

          const paymentObject = new window.Razorpay(options);
          paymentObject.on("payment.failed", async function (response) {
            try {
              console.error(
                "Error in processing order from razor pay",
                response
              );
              openEventModal(
                EVENT_MODAL_ERROR,
                "There was an issue with processing the order. We request you to keep a note of the transaction. If payment succeeded and your account is not activated in 3 days, please contact support +91 8296919479."
              );
              const cancelResponse = await cancelOrder(
                auth.token,
                orderData.orderId
              );
              if (!cancelResponse.data.data.cancelOrder) {
                console.error(
                  "failed to cancel transaction, received error",
                  cancelResponse.data.errors
                );
                setTimeout(() => closeEventModal(), 5000);
              }
            } catch (error) {
              toast.info(
                "Transaction is being validated. If cancelled, please retry payment after some time",
                { timeOut: 1000 }
              );
              console.error("error in cancelling the payment", error);
            }
          });
          paymentObject.open();
        }
      } catch (error) {
        openEventModal(
          EVENT_MODAL_ERROR,
          "There was an unexpected issue. If payment succeeded, we request you to keep a note of the transaction. If your account is not activated in 3 days of payment, please contact support +91 8296919479."
        );
        console.error("Error in creating order:", error);
      }
    } else {
      console.error("Authentication failed, no token found");
      openEventModal(
        EVENT_MODAL_ERROR,
        "There was an unexpected issue. Please try refreshing and attempt payment after some time.",
        true
      );
    }
  };
  
  //apply filter first time someone logs in
  React.useEffect(() => {
    if(areFiltersLoaded)
      applyProfileFilter(areFiltersLoaded);
  }, [areFiltersLoaded]);

  React.useEffect(() => {
    return () => {
      if(timerRef.current) {
        clearTimeout(timerRef.current);
      }
    }
  }, []);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  React.useEffect(() => {
    localStorage.setItem(LOCALSTORAGE_HOMEPAGE_PAGENUMBER, currentPage);
    applyProfileFilter(false, currentPage);
  }, [currentPage]);

  // Update searchTextRef whenever searchText changes
  React.useEffect(() => {
    searchTextRef.current = searchText;
    invokeApplyProfileFilterWithDelay(null, null, 1500);
  }, [searchText]);

  const resetSearchText = () => {
    setSearchText("");
  }

  // Show preview modal for unpaid users who haven't seen it
  React.useEffect(() => {
    if (!isUserPaymentValid && shouldUserViewPreviewIntro) {
      setPreviewModalOpen(true);
    }
  }, [isUserPaymentValid, shouldUserViewPreviewIntro]);

  const handlePreviewClose = () => {
    setPreviewModalOpen(false);
  };

  const handlePreviewUpgrade = () => {
    setPreviewModalOpen(false);
    setPaymentModalOpenState(true);
  };

  return (
    <>
      <ToastContainer />

      <div ref={headerRef}>
        <Header
          heading="GSB Soirika"
          subtext="Your road to live happily ever after"
          searchText={searchText}
          setSearchText={setSearchText}
          invokeApplyFilterWithDelay={invokeApplyProfileFilterWithDelay}
          renderPreviewModal={() => setPreviewModalOpen(true)}
        />
      </div>

      <div className="container-fluid mt-1 mb-1">
        <div className="row home-row">
          <div className="p-1 col-xs-12 col-sm-12 col-md-4 col-lg-3 relative">
            <ProfileFilters
              applyProfileFilter={applyProfileFilter}
              filterState={localFilterState}
              setFilterState={setLocalFilterState}
              appliedFilters={filterState}
              resetSearchText={resetSearchText}
            />
          </div>
          <div className="col p-1 home-profiles">
            {loading || !firstRenderCompleted ? (
              <div className="flex justify-center">
                <span className="loading loading-dots loading-lg"></span>
              </div>
            ) : (
              <AllProfiles 
                profiles={[...filteredProfiles]}
                handleMakePayment={() => {
                  setPaymentModalOpenState(true)
                }}
              />
            )}

            <PaymentModal
              open={paymentModalOpenState}
              onClose={() => setPaymentModalOpenState(false)}
            />

            {/* Preview Modal */}
            <PreviewModal
              open={previewModalOpen}
              handleClose={handlePreviewClose}
              onUpgrade={handlePreviewUpgrade}
            />

            <GenericModal
              open={eventModalOpenState}
              onClose={closeEventModal}
              message={eventModalText}
              type={eventModalType}
            />
          </div>
        </div>
        <div className="mx-auto">
          <div className="flex items-center justify-center">
            <Stack spacing={2}>
              <Pagination
                color="primary"
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                showFirstButton
                showLastButton
              />
            </Stack>
          </div>
        </div>
      </div>
    </>
  );
}

export default HomePage;
